export default "__VITE_ASSET__CoqfgYhM__"